import { render } from "./pos-customers.vue?vue&type=template&id=61405d78"
import script from "./pos-customers.vue?vue&type=script&lang=js"
export * from "./pos-customers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__